module.exports = __webpack_public_path__ + "img/candy.3c580786.png";